
const teamSummaryMatchupDataRequestAction = () => {
    return (dispatch, getState, { componentDataEngine }) => {
        const state = getState();
        const {
            gamePk,
            gameData: {
                game: { season },
                datetime: { officialDate } = {},
                teams: { home, away } = {}
            }
        } = state.gumbo;

        const homeLeague = home?.league?.id;
        const awayLeague = away?.league?.id;

        const leagueIds = [];

        if (homeLeague) {
            leagueIds.push(homeLeague);
        }
        if (awayLeague && awayLeague !== homeLeague) {
            leagueIds.push(awayLeague);
        }

        const leagueIdsParam = leagueIds.join(',');
        return componentDataEngine.fetchAndStore('standings', { gamePk, leagueIds: leagueIdsParam, gameDate: officialDate, season });
    };
};

export default teamSummaryMatchupDataRequestAction;
